import { prefixObjectValues as pre } from '../utils';

const prefix = 'account-documents-table';

const columns = pre(
  {
    docName: 'doc-name',
    uploadedAt: 'uploaded-at',
    docDesc: 'doc-desc',
    deleteAction: 'delete-action',
    downloadAction: 'download-action',
    parseAction: 'parse-action',
    editAction: 'edit-action',
  },
  prefix + '-column'
);

const table = pre(
  {
    grid: 'grid',
    dropUploadTarget: 'drop-upload-target',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
  columns,
};
